import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import { GWElement } from 'lib/elements'
import { kebabCase } from 'change-case'
import { getDependency } from 'utils/gw'
import { enhanceSwiperAccessibility } from 'utils/swiper-accessibility'

const SWIPER_MODULE_OPTIONS = [
  'a11y',
  'autoplay',
  'controller',
  'freeMode',
  'grid',
  'hashNavigation',
  'history',
  'keyboard',
  'manipulation',
  'mousewheel',
  // 'navigation',
  'pagination',
  'parallax',
  'scrollbar',
  'thumbs',
  'virtual',
  'zoom',
]

export class SwiperElement extends GWElement {
  constructor() {
    super()
  }

  get optionDefaults() {
    return {
      modules: [Navigation],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        disabledClass: 'swiper-button-disabled',
      },
      autoplay: false,
      autoHeight: false,
      effect: 'slide',
      spaceBetween: 0,
      slidesPerView: 1,
      loop: false,
      centeredSlides: false,
      breakpoints: {},
      freeMode: false,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,

      watchSlidesProgress: false,
      initialSlide: undefined,
      pagination: false,
      scrollbar: false,
      thumbs: false,
      zoom: false,
      a11y: {
        enabled: true,
        containerRole: 'group',
        containerRoleDescriptionMessage: 'carousel',
        itemRoleDescriptionMessage: 'slide',
        prevSlideMessage: 'Previous slides',
        nextSlideMessage: 'Next slides',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      watchSlidesProgress: true,
      // TODO: Figure out how to pass callback
      // on: null

      config: {},
    }
  }

  get config() {
    const { config, ...options } = this.options
    return { ...config, ...options }
  }

  async getModules() {
    const { effect, modules } = this.options
    const optionKeys = Object.keys(this.options).filter(key => {
      const value = this.options[key]
      if (typeof value === 'object') {
        return Array.isArray(value) ? value.length > 0 : Object.keys(value).length > 0
      }

      return !!value
    })
    const optionModules = SWIPER_MODULE_OPTIONS.filter(key => optionKeys.includes(key))

    const effectModule = effect !== 'slide' ? `effect-${effect}` : null

    return await Promise.all(
      [...optionModules, ...modules, effectModule].filter(Boolean).map(async moduleIdentifier => {
        if (typeof moduleIdentifier !== 'string') return moduleIdentifier

        console.debug('Loading Swiper module:', moduleIdentifier)
        try {
          await getDependency(`swiper/modules/${kebabCase(moduleIdentifier)}`, { type: 'css' })
        } catch (error) {
          console.debug('Failed to load Swiper module stylesheet:', moduleIdentifier)
        }
        return await getDependency(`swiper/modules/${kebabCase(moduleIdentifier)}`)
      })
    )
  }

  processSwiperOption(key, value) {
    if (typeof value === 'object' && !Array.isArray(value)) {
      return Object.fromEntries(Object.entries(value).map(([key, value]) => [key, this.processSwiperOption(key, value)]))
    }

    if (key.includes('slidesOffset') && value === 'edge') {
      return () => parseInt(getComputedStyle(document.querySelector('.header')).getPropertyValue('padding-inline'), 10)
    }

    return value
  }

  parseOptions() {
    console.log(this.options)
    const options = { ...this.options }
    for (const [key, value] of Object.entries(options)) {
      options[key] = this.processSwiperOption(key, value)
    }
    console.log('OPTIONS?', options)
    return options
  }

  async init() {
    super.init()

    const modules = await this.getModules()

    const options = this.parseOptions()
    console.log('OPTIONS', options)

    this.swiper = new Swiper(this, {
      ...options,
      modules,
    })
    enhanceSwiperAccessibility(this.swiper)
  }

  destroy() {
    super.destroy()

    this.swiper.destroy()
  }
}

if (!customElements.get('swiper-element')) {
  customElements.define('swiper-element', SwiperElement)
}
